import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionManagerService } from '../services/index';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class RouteGuard implements CanActivate {
  constructor(
    private sessionManagerService: SessionManagerService,
    private router: Router,
  ) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const { token = '', roleId = '' } = this.sessionManagerService.getTokenAndRole();
    if (token && roleId && (roleId === '1' || roleId === '3')) {
      return true;
    } else {
      this.sessionManagerService.logout();
      this.router.navigate(['']);
      return false;
    }
  }
  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
